(function () {
  'use strict';

  angular
    .module('morningFlightPriorToLayoverNight')
    .controller('morningFlightPriorToLayoverNightCtrl', morningFlightPriorToLayoverNightCtrl);

  function morningFlightPriorToLayoverNightCtrl(CommonMasterData, morningFlightPriorToLayoverNightService ,MessageService, $compile,$scope,StorageServices,TabService,applicationConstants) {
    var vm = this;
    vm.ctrlName = 'morningFlightPriorToLayoverNightCtrl';

    vm.model = {
      searchPanelToggle: true,
      width: window.screen.width,
      height:window.screen.height,
      searchOnGoing: false,
      totalNumberOfRecords:null,
      searchCriteria: {
        fromDate: null,
        toDate: null,
        crewType: null,
        base: null,
        autoOrManual : null,
        destinations: null,
      },
      masterList: {
        crewTypeList: [],
        baseTypes: [],
        destinationList: [],
        fromDateFormatInvalid: false,
        toDateFormatInvalid: false,
        fromDateAfterToDate: false,
        autoManualList : [{'autoOrManualCode':'M', 'autoOrManualDesc':'Manual'}, {'autoOrManualCode':'A', 'autoOrManualDesc':'Auto'}]

      },
      lastSearchDates:{
        fromDate:null,
        toDate:null
      },
      morningFlightPriorToLayoverNightList: [],
      initialSearchDone: false
    };

    vm.clickOnSearch = function () {
      vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
      vm.model.initialSearchDone = false;
    };

    var dataObject = [];
    var hotSettings = [];
    var hot;

    vm.submitSearch = function (params) {
      morningFlightPriorToLayoverNightService.searchMorningFlightPriorToLayoverNight(params,
        function (response) {
          vm.model.lastSearchDates.fromDate = vm.model.searchCriteria.fromDate;
          vm.model.lastSearchDates.toDate = vm.model.searchCriteria.toDate;
          vm.model.morningFlightPriorToLayoverNightList = response.morningFlightPriorToLayoverNightResponseDTOS;
          vm.model.searchPanelToggle = false;
          vm.model.totalNumberOfRecords = response.morningFlightPriorToLayoverNightResponseDTOS.length;
          dataObject = vm.dataObject();
          hotSettings = vm.hotSettings();
          hot = new Handsontable(hotElement, hotSettings);
          $compile(hotElement)($scope);
        },
        function (error) {
          MessageService.error(error[0]);
        }
      );
    };

    vm.dataObject = function () {
      var dataObject = [];

      for (var i in vm.model.morningFlightPriorToLayoverNightList) {
        dataObject.push({
          ROW_NUMBER : parseInt(i)+1,
          CREW_NAME: vm.model.morningFlightPriorToLayoverNightList[i].crewName,
          CREW_ID: vm.model.morningFlightPriorToLayoverNightList[i].crewID,
          CREW_TYPE_CODE: vm.model.morningFlightPriorToLayoverNightList[i].crewType,
          AUTO: vm.model.morningFlightPriorToLayoverNightList[i].autoOrManual,
          MORNING_FLIGHT_ORIGIN: vm.model.morningFlightPriorToLayoverNightList[i].morningFlightOrigin,
          MORNING_FLIGHT_DESTINATION: vm.model.morningFlightPriorToLayoverNightList[i].morningFlightDestination,
          MORNING_FLIGHT_DEPARTURE: vm.model.morningFlightPriorToLayoverNightList[i].morningFlightDeparture,
          MORNING_FLIGHT_ARRIVAL: vm.model.morningFlightPriorToLayoverNightList[i].morningFlightArrival,
          NIGHT_LAYOVER_ORIGIN: vm.model.morningFlightPriorToLayoverNightList[i].nightLayoverOrigin,
          NIGHT_LAYOVER_DESTINATION: vm.model.morningFlightPriorToLayoverNightList[i].nightLayoverDestination,
          NIGHT_LAYOVER_DEPARTURE: vm.model.morningFlightPriorToLayoverNightList[i].nightLayoverDeparture,
          NIGHT_LAYOVER_ARRIVAL: vm.model.morningFlightPriorToLayoverNightList[i].nightLayoverArrival,
          RN_FL1: vm.model.morningFlightPriorToLayoverNightList[i].rnFl1,
          RN_FL2: vm.model.morningFlightPriorToLayoverNightList[i].rnFl2,
        })
      }
      return dataObject;
    };

    vm.hotSettings = function () {
      var hotSettings = {
        data: dataObject,
        undo: true,
        redo: true,
        copy: true,
        paste: true,
        manualColumnResize: true,
        copyRowsLimit: 1000000,
        colWidths: [vm.model.width * 0.05, vm.model.width * 0.075, vm.model.width * 0.05, vm.model.width * 0.05, vm.model.width * 0.05, vm.model.width * 0.05, vm.model.width * 0.05, vm.model.width * 0.1, vm.model.width * 0.1, vm.model.width * 0.05, vm.model.width * 0.05, vm.model.width * 0.1, vm.model.width * 0.1, vm.model.width * 0.05, vm.model.width * 0.05],
        columns: [
          {
            data: 'ROW_NUMBER',
            type: 'numeric',
            readOnly: true
          },
          {
            data: 'CREW_NAME',
            renderer: 'html',
            readOnly: true
          },
          {
            data: 'CREW_ID',
            type: 'text',
            readOnly: true
          },
          {
            data: 'CREW_TYPE_CODE',
            type: 'text',
            readOnly: true
          },
          {
            data: 'AUTO',
            type: 'text',
            readOnly: true
          },
          {
            data: 'MORNING_FLIGHT_ORIGIN',
            type: 'text',
            readOnly: true
          },
          {
            data: 'MORNING_FLIGHT_DESTINATION',
            type: 'text',
            readOnly: true
          },
          {
            data: 'MORNING_FLIGHT_DEPARTURE',
            type: 'text',
            readOnly: true
          },
          {
            data: 'MORNING_FLIGHT_ARRIVAL',
            type: 'text',
            readOnly: true
          },
          {
            data: 'NIGHT_LAYOVER_ORIGIN',
            type: 'text',
            readOnly: true
          },
          {
            data: 'NIGHT_LAYOVER_DESTINATION',
            type: 'text',
            readOnly: true
          },
          {
            data: 'NIGHT_LAYOVER_DEPARTURE',
            type: 'text',
            readOnly: true
          },
          {
            data: 'NIGHT_LAYOVER_ARRIVAL',
            type: 'text',
            readOnly: true
          },
          {
            data: 'RN_FL1',
            type: 'text',
            readOnly: true
          },
          {
            data: 'RN_FL2',
            type: 'text',
            readOnly: true
          },],

        stretchH: 'all',
        width: vm.model.width * 0.99,
        autoWrapRow: true,
        height: vm.model.height,
        rowHeaders: true,
        colHeaders: [
          '',
          'Crew Name',
          'Crew Id',
          'Crew Type',
          'Auto/Manual',
          'Morning Flight Origin',
          'Morning Flight Destination',
          'Morning Flight Departure',
          'Morning Flight Arrival',
          'Night Layover Origin',
          'Night Layover Destination',
          'Night Layover Departure',
          'Night Layover Arrival',
          'RN FL1',
          'RN FL2',
        ]
      };

      return hotSettings;
    };

    var hotElement = document.querySelector('#hot');


    function setDateValidationFlags() {
      if (isDateFormatInvalid(vm.model.searchCriteria.fromDate)) {
        vm.model.masterList.fromDateFormatInvalid = true;
      } else {
        vm.model.masterList.fromDateFormatInvalid = false;
      }
      if (isDateFormatInvalid(vm.model.searchCriteria.toDate)) {
        vm.model.masterList.toDateFormatInvalid = true;
      } else {
        vm.model.masterList.toDateFormatInvalid = false;
      }
    }


    vm.changeSearchField = function (searchParams, flag) {
      setDateValidationFlags();
      if (!vm.model.masterList.toDateFormatInvalid
        && !vm.model.masterList.fromDateFormatInvalid) {
        if (istoDateBeforeFromDate()) {
          vm.model.masterList.fromDateAfterToDate = true;
        } else {
          vm.model.masterList.fromDateAfterToDate = false;

        }
      } else {
        vm.model.masterList.fromDateAfterToDate = false;
      }

    };


    function isDateFormatInvalid(date) {
      if (!!date && !moment(date, "DD/MM/YYYY").isValid()) {
        return true;
      }
      return false;
    }

    function istoDateBeforeFromDate() {
      return moment(vm.model.searchCriteria.toDate, "DD/MM/YYYY")
        .isBefore(
          moment(vm.model.searchCriteria.fromDate,
            "DD/MM/YYYY"));
    };

    (function (){
        CommonMasterData.getCrewBaseList(
          function (crewBase) {
            vm.model.masterList.baseTypes = crewBase;
          }, function () {

          }
        );
      }
    )();

    (function () {
      CommonMasterData.getCrewTypeList(function (crewTypeList) {
        vm.model.masterList.crewTypeList = crewTypeList;
      }, function () {
        console.log('Crew Type list retrieval error');
      });

    })();

    (function () {
      CommonMasterData.getAirportList(function (destinationList) {
        vm.model.masterList.destinationList = destinationList;
      }, function () {
        console.log('Airport list retrieval error');
      });

    })();
  }
}());
